import {FETCH_CPVALUE_SUCCESS_ACTION} from './action';

const initialState = {
  processing: false,
  error: false,
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CPVALUE_SUCCESS_ACTION:
      console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@', action.payload);
      return {
        ...state,
        CpvalueList: action.payload,
        // CpvalueDtlsCount: action.payload.count,
      };

    default:
      return {
        ...state,
      };
  }
}
